import { render, staticRenderFns } from "./PurchasesTab.vue?vue&type=template&id=23376930&scoped=true"
import script from "./PurchasesTab.vue?vue&type=script&lang=js"
export * from "./PurchasesTab.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTab.vue?vue&type=style&index=0&id=23376930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23376930",
  null
  
)

export default component.exports